import { createContext } from "react";
import { DefaultContext } from "../constants/context/context";

export const CommonContext = createContext(DefaultContext);
